import React from 'react';
import { ASK_COPY } from '../../utils/askScope';

// Evidence rows: Endpoint | Field | Value. A row with a `rowRef` that is still live is a button
// that calls onJump(rowRef). A rowRef that is no longer live is muted and says why. A row with no
// rowRef at all (e.g. a counted session figure) is plain text. Presentational: no fetch.
// `isRowLive(rowRef)` is optional; absent means "assume live".
export default function EvidenceTable({ evidence, onJump, isRowLive }) {
  const rows = Array.isArray(evidence) ? evidence.filter((e) => e && typeof e === 'object') : [];
  if (!rows.length) return null;
  return (
    <div className="ask-evidence">
      <table className="ask-evidence-table">
        <caption className="sr-only">Evidence</caption>
        <thead>
          <tr><th scope="col">Endpoint</th><th scope="col">Field</th><th scope="col">Value</th></tr>
        </thead>
        <tbody>
          {rows.map((e, i) => {
            // `requestId` (server-stamped, the row's own id) makes a row jumpable even without a usable rowRef.
            const hasRef = (e.rowRef !== undefined && e.rowRef !== null && e.rowRef !== '')
              || (typeof e.requestId === 'string' && e.requestId !== '');
            const live = hasRef && (typeof isRowLive === 'function' ? !!isRowLive(e.rowRef, e) : true);
            let endpoint = <span>{e.endpoint}</span>;
            if (hasRef && live && typeof onJump === 'function') {
              endpoint = (
                <button
                  type="button"
                  className="evidence-chip"
                  aria-label={`Open request ${e.endpoint} in Raw requests`}
                  onClick={() => onJump(e.rowRef, e)}
                >
                  {e.endpoint}
                </button>
              );
            } else if (hasRef && !live) {
              endpoint = (
                <>
                  <span className="evidence-chip is-muted" aria-disabled="true">{e.endpoint}</span>
                  <div className="ask-muted-note">{ASK_COPY.noLiveRow}</div>
                </>
              );
            }
            return (
              <tr key={i}>
                <td>{endpoint}</td>
                <td>{e.field}</td>
                <td className="ask-mono">{e.value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
